import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';

import { UrlParamKeys } from '~commonInfra/url/UrlParamKeys';
import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { enterSpace } from '~src/spacesPlatform/actions/EnterSpaceAction';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';
import { setOrderAction } from '~src/spacesPlatform/actions/SetOrderAction';
import { getOrderClausesFromQueryParam } from '~src/spacesPlatform/components/Explorer/ExplorerUrlBindings';
import { getDefaultOrderForFlowSubSpace } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../codegen/Localize';
import { EnterFlowSubspaceReduxAction } from '../actions/EnterFlowSubspaceAction';

export function* handleEnterFlowSubspace(action: EnterFlowSubspaceReduxAction): SagaIterator {
  try {
    const spaceInfo: SpaceInfo = {
      item: action.flowDetailInfo,
      spaceType: 'flow',
      subspaceName: action.subspaceName,
    };
    yield put(enterSpace(spaceInfo));
    const hashQuery: any = WindowLocationService.getHashQueryObject();
    const orderFromQuery = getOrderClausesFromQueryParam(
      hashQuery[UrlParamKeys.Order],
      getDefaultOrderForFlowSubSpace(spaceInfo)
    );
    yield put(setOrderAction(orderFromQuery));
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}
